<i18n>
{
    "de": {
        "transformer": "Transformator",
        "transformer70": "Elektronischer Transformator 70 VA, kompakte Bauform",
        "transformer105": "Elektronischer Transformator 105 VA, kompakte Bauform",
        "transformer210": "Elektronischer Transformator 210 VA, für primäre Durchgangsverdrahtung geeignet",
        "type": "Typ",
        "voltage": "Spannung",
        "dimmable": "Dimmbar"
    },
    "en": {
        "transformer": "Transformer",
        "transformer70": "Electronic transformer 70 VA, compact design",
        "transformer105": "Electronic transformer 105 VA, compact design",
        "transformer210": "Electronic transformer 210 VA, for primary feed-through wiring",
        "type": "Type",
        "voltage": "Voltage",
        "dimmable": "Dimmable"
    }
}
</i18n>

<template>
  <div>
    <div class="mt-5" v-for="(transformer, index) in transformers" :key="index">
      <!-- <b style="font-size: 15px">{{ transformer.name }}</b
            >:  -->
      {{ transformer.description }}
      <div class="c-transformer__grid">
        <div class="c-transformer__tableheader">Code</div>
        <div class="c-transformer__tableheader d-none d-md-block">
          {{ $t("type") }}
        </div>
        <div class="c-transformer__tableheader">LED</div>
        <div class="c-transformer__tableheader">
          {{ $t("voltage") }}
        </div>
        <div class="c-transformer__tableheader">
          {{ $t("dimmable") }}
        </div>
        <div class="c-transformer__tableheader d-none d-md-block">
          LxWxH (mm)
        </div>
        <div>
          {{ transformer.items[0] }}
        </div>
        <div class="d-none d-md-block">
          {{ transformer.items[1] }}
        </div>
        <div>
          {{ transformer.items[2] }}
        </div>
        <div>
          {{ transformer.items[3] }}
        </div>
        <div>
          {{ transformer.items[4] }}
        </div>
        <div class="d-none d-md-block">
          {{ transformer.items[5] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      transformers: [
        {
          name: "Transformator 70 VA",
          description: this.$t("transformer70"),
          items: [
            "ETZ 70",
            this.$t("transformer") + " 0-70 VA",
            "max. 60 W",
            "12V / 240V",
            "phase dim",
            "95x42x28",
          ],
        },
        {
          name: "Transformator 105 VA",
          description: this.$t("transformer105"),
          items: [
            "LUXIA 105",
            this.$t("transformer") + " 0-105 VA",
            "max. 60 W",
            "12V / 240V",
            "phase dim",
            "119x37x35",
          ],
        },
        {
          name: "Transformator 210 VA",
          description: this.$t("transformer210"),
          items: [
            "ETZ 210",
            this.$t("transformer") + " 0-210 VA",
            "max. 180 W",
            "12V / 240V",
            "phase dim",
            "167x53x39",
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.c-transformer {
  &__grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    // grid-gap: 10px;

    @include media-breakpoint-down(sm) {
      grid-template-columns: repeat(4, auto);
    }

    > div {
      padding: 10px 10px 10px 0;
      &:nth-child(6n + 2) {
        width: 170px;
      }
    }
  }
  &__tableheader {
    border-bottom: 1px solid $grey-dark;
    // text-transform: uppercase;
    font-weight: bold;
    padding: 20px 10px 20px 0;
  }
}
</style>
